(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bbc-media"] && !Shopify.designMode) return;
  try {
    (function () {
  var pre = false;
  function preconnect() {
    if (pre) return; pre = true;
    ['https://www.youtube-nocookie.com', 'https://i.ytimg.com', 'https://player.vimeo.com'].forEach(function (h) {
      var l = document.createElement('link'); l.rel = 'preconnect'; l.href = h; document.head.appendChild(l);
    });
  }
  document.addEventListener('pointerover', function (e) {
    if (e.target.closest && e.target.closest('.bbc-media--playable')) preconnect();
  }, { passive: true });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bbc-media__play');
    if (!btn) return;
    var m = btn.closest('.bbc-media');
    if (!m || m.classList.contains('is-playing') || m.classList.contains('is-loading')) return;
    // play inline even when the media sits inside a linked card — don't navigate
    e.preventDefault();
    e.stopPropagation();
    preconnect();
    var frame = document.createElement('div');
    frame.className = 'bbc-media__frame';
    var kind = m.getAttribute('data-bbc-embed');
    // sanitise: video ids are alphanumeric / dash / underscore only
    var id = (m.getAttribute('data-bbc-id') || '').replace(/[^A-Za-z0-9_-]/g, '');
    var media = null;
    if ((kind === 'youtube' || kind === 'vimeo') && id) {
      var ifr = document.createElement('iframe');
      ifr.src = kind === 'youtube'
        ? 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1&fs=1'
        : 'https://player.vimeo.com/video/' + id + '?autoplay=1&title=0&byline=0';
      ifr.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
      ifr.setAttribute('allowfullscreen', '');
      ifr.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      ifr.setAttribute('title', 'Video');
      frame.appendChild(ifr);
      media = ifr;
    } else {
      var tpl = m.querySelector('.bbc-media__file');
      if (!tpl || !tpl.content) return;
      frame.appendChild(tpl.content.cloneNode(true));
      var v = frame.querySelector('video');
      if (v) { v.setAttribute('autoplay', ''); v.setAttribute('playsinline', ''); if (v.play) { v.play().catch(function () {}); } media = v; }
    }
    // loading → playing: poster stays (dimmed, spinner) until the player is ready
    m.classList.add('is-loading');
    m.appendChild(frame);
    var done = false;
    function ready() { if (done) return; done = true; m.classList.remove('is-loading'); m.classList.add('is-playing'); }
    if (media) { media.addEventListener('load', ready); media.addEventListener('loadeddata', ready); }
    setTimeout(ready, 4000); /* fallback: never strand the loading state */
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bbc-press"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
  var btn = e.target.closest('.bbc-press__pause');
  if (!btn) return;
  var reel = btn.closest('.bbc-press__reel');
  var paused = reel.classList.toggle('is-paused');
  btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
  btn.setAttribute('aria-label', paused ? 'Play the press quotes' : 'Pause the press quotes');
  btn.textContent = paused ? '▶' : '❚❚'; /* static glyphs, not markup */
});
  } catch(e) { console.error(e); }
})();

})();
